
import $ from "jquery"

import Modal from "app/modal/show-modal"
import SaveManager from "concepts/listings/searches/saved/manager"
import ShouldSaveSearchNotice from "app/notifications/should_save_search_notice/index"

const init = () => {
  if ($(".cell-listings-searches-saved-prompt-modal--save").length === 0) { return }

  if (ShouldSaveSearchNotice.notice_is_disabled()) { return }

  const $modal = Modal.showModalWithSelector(".cell-listings-searches-saved-prompt-modal--save", {customContent: true})
  if ($modal == null) { return }

  ShouldSaveSearchNotice.disable_notice()

  $modal.on("click", (e: Event) => {
    if (e.target == null) { return }

    const $target = $(e.target)

    if (!$target.is(".btn-save")) { return }

    SaveManager.emit("save_click")
  })
}

export default {init}
